/* eslint-disable class-methods-use-this */
// import networkBoundResource from '@/data/networkBoundResource'
import store from '@/store'
import { Response } from '@/utils/helpers/response'

class Repository {
  remote: any

  sourceDb: any

  savingData: any

  constructor(remote: any, sourceDb: any, savingData: any = null) {
    this.remote = remote
    this.sourceDb = sourceDb
    if (savingData) {
      this.savingData = savingData
    }
  }

  private result = async (haveLocal: boolean) => {
    const data = new Response()
    // if (store.state.network.connection) {
    try {
      const fetch = await this.fetchData().run()
      const code = fetch.status
      const result = fetch.data
      if (code === 201) {
        data.result = fetch.data
        data.message = fetch.data.Detail
      } else if (code === 200 || code === 204) {
        // eslint-disable-next-line no-prototype-builtins
        if (typeof result.Data === 'object' || Array.isArray(result.Data)) {
          data.result = result.Data
          data.count = result.Count
          data.pagesize = result.PageSize
          data.pagenumber = result.PageNumber
          data.message = result.Header && result.Detail ? `${result.Header} ${result.Detail}` : 'berhasil ditampilkan'
        } else {
          data.message = `${result.Header} ${result.Detail}`
          data.result = result
        }
      } else {
        data.error = true
        data.message = `${fetch.data.Header} ${fetch.data.Detail}`
        data.result = fetch.data.Data
      }
      data.code = fetch.status
    } catch (e: any) {
      if (typeof e.response === 'undefined') {
        data.error = true
        data.message = 'A network error occurred. This could be a CORS issue or a dropped internet connection. It is not possible for us to know.'
        data.result = ''
        // return Promise.reject(e)
        return data
      }
      if (e.response.status === 400) {
        data.error = true
        data.arrayMessage = e.response.data?.errors ?? null
        const errors = e.response.data?.errors
        if (errors && typeof errors === 'object') {
          data.message = Object.values(errors).flat().join(', ')
        } else {
          data.message = e.response.data?.message || e.response.data?.title || 'Terjadi kesalahan validasi'
        }
        data.code = (e.response) ? e.request.status : 400
      } else if (e.response.status === 401) {
        data.error = true
        data.message = `${e.response.data.Header} ${e.response.data.Detail}`
        data.code = (e.response) ? e.request.status : 401
      } else if (e.response.status === 405) {
        // console.log('e', e.response)
        data.error = true
        data.message = 'Anda tidak memiliki akses. Silahkan hubungi Admin'
        data.code = (e.response) ? e.request.status : 405
      } else if (e.response.status === 502) {
        data.error = true
        data.message = 'Cek koneksi internet anda'
        data.code = (e.response) ? e.request.status : 502
      } else {
        data.error = true
        data.message = 'Gagal mengambil data'
        data.code = (e.response) ? e.request.status : 500
      }
    }
    if (haveLocal) {
      this.saveResultData(data)
    }
    // } else if (haveLocal) {
    //   data.result = await this.loadFromDB()
    // } else {
    //   store.dispatch('setNoInternet', true)
    // }

    return data
  }

  loadFromDB() {
    return this.sourceDb
  }

  fetchData() {
    return this.remote
  }

  saveResultData(data: any): void {
    this.sourceDb.changeData(data)
    this.loadFromDB().run()
    // console.log('save result data', data)
  }

  getResult = async (haveLocal: boolean): Promise<Response> => {
    const data = await this.result(haveLocal)
    return data
  }
}

export default Repository
